import createPictogram from '../createPictogram'
import svg from './Gender.svg'

export default createPictogram(svg)
